<script setup lang="ts">
const { t } = useI18n()

useHead({
  link: [{
    rel: 'canonical',
    href: `${import.meta.env.VITE_MONOLITH_URL}/contact-us`,
  }],
})

useSeoMeta({
  title: t('contact_us.meta.title'),
  description: t('contact_us.meta.description'),
  ogTitle: t('contact_us.meta.title'),
  ogDescription: t('contact_us.meta.description'),
  ogImage: `${S3_ASSETS_URL}/meta-default.jpg`,
})
</script>

<template>
  <div class="isolate flex min-h-dvh flex-col">
    <LayoutNavbarAlt />

    <div class="grow bg-[#f8f8f0]">
      <ContactSplashScreen />
    </div>
  </div>
</template>
